<script setup>
import PackageTable from '@frontJs/components/tables/projectManagement/apikom/PackageTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Forfaits - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Forfaits </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(PackageTable),
            },
            seo: {
                title: 'SEO/GEO',
                content: h(PackageTable, { theme: 'seo' }),
            },
            sea: {
                title: 'SEA',
                content: h(PackageTable, { theme: 'sea' }),
            },
            smo: {
                title: 'SMO',
                content: h(PackageTable, { theme: 'smo' }),
            },
            sma: {
                title: 'SMA',
                content: h(PackageTable, { theme: 'sma' }),
            },
            sem: {
                title: 'SEM',
                content: h(PackageTable, { theme: 'sem' }),
            },
            dev: {
                title: 'DEV',
                content: h(PackageTable, { theme: 'dev' }),
            },
            hosting: {
                title: 'Hébergement',
                content: h(PackageTable, { theme: 'hosting' }),
            },
            outsourcing: {
                title: 'Infogérance',
                content: h(PackageTable, { theme: 'outsourcing' }),
            },
            cloudflare: {
                title: 'Cloudflare',
                content: h(PackageTable, { theme: 'cloudflare' }),
            },
            emailing: {
                title: 'Emailing',
                content: h(PackageTable, { theme: 'emailing' }),
            },
            shoppingfeed: {
                title: 'Shoppingfeed',
                content: h(PackageTable, { theme: 'shoppingfeed' }),
            },
            performance: {
                title: 'Performance',
                content: h(PackageTable, {
                    theme: 'performance_stage',
                }),
            },
            days: {
                title: 'Jours',
                content: h(PackageTable, {
                    theme: 'days',
                }),
            },
            special: {
                title: 'Spécial',
                content: h(PackageTable, { theme: 'special' }),
            },
        }"
    />
</template>
